import React, {useState, useEffect} from "react";
import {Form, Col, Input, DatePicker, Select, Collapse, Card, notification} from 'antd';
import jsonfile from './balancesheet.json'
import {Link, useHistory} from "react-router-dom";
import {CisUI} from '../../../../util/CISUI';
import AdvancedSearch from '../../../../util/AdvancedSearch';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import moment from "moment";

const Panel = Collapse.Panel;


const BalanceSheet = () => {
    const value = 0;
    const [state, setState] = useState({
        reqURL: Config.apiserver + jsonfile.urls.list,
        filtervalue: '',
        subtitle: '',
        period: "For the end of " + CisUI().getMonthTitle(moment().format("YYYY-12-31")),
        currentYear: "as of " + CisUI().getMonthTitle(moment().format("YYYY-12-31")),
        lastYear: '',
        reporttype: "periodical"
    });

    const dt = CisUI().getCurrentYearDateRange;
    const [dateset, setDate] = useState(dt);
    const [header, setHeader] = useState("");
    const [period, setPeriod] = useState("For the end of " + CisUI().getMonthTitle(moment().format("YYYY-12-31")));
    const [reportyear, setReportYear] = useState({
        currentYear: "as of " + CisUI().getMonthTitle(moment().format("YYYY-12-31")),
        lastYear: ""
    });

    const [resp, setResp] = useState({
        status: 0,
        msg: "Balance Sheet",
        company: {},
        data: []
    });

    const [hide, setHide] = useState([]);
    const [reporttype, setReportType] = useState("periodical");
    const [company, setCompany] = useState({});

    const ref = React.createRef();
    const formRef = React.createRef();

    const [data, setData] = useState([]);

    useEffect(() => {
        if (CisUI().getUserInfo('com_id') > 0) {
            getLedgerData();
        }
    }, []);


    const getLedgerData = (url = "") => {
        document.getElementById("loader").style.display = "block";
        let urls = state.reqURL;
        if (url !== "") {
            urls = url;
        }
        axios.get(urls)
            .then(res => {
                //console.log(res)
                if (res.data.status === 1) {
                    setResp(res.data);
                    //setData(res.data.data);
                    //console.log(res.data.data.assets[0].currentAsset);
                    //console.log(res.data.data[0]["assets"]["currentAsset"]);
                    setCompany(res.data.company);
                    setHeader(res.data.company.legal_name);

                } else {
                    notification.warning({
                        message: 'Alert',
                        type: "warning",
                        description: res.data.msg
                    });
                }
                document.getElementById("loader").style.display = "none";
            })
            .catch(errors => {
                console.log(errors.response.data.errors);
                document.getElementById("loader").style.display = "none";
            });
    }

    const history = useHistory();

    const getDetailsLink = (source,id) => {
        // if(source === 'Bill Payment') {
        //     return "../../"+jsonfile.detaillink.bill+"/"+id+"?date="+dateset;
        // }
        // else if(source === 'Journal') {
        //     return "../../"+jsonfile.detaillink.journal+"/"+id+"?date="+dateset;
        // }
        // else if(source === 'Vendor Bill') {
        //     return "../../"+jsonfile.detaillink.bill+"/"+id+"?date="+dateset;
        // }
        // else if(source === 'Ledger') {
        //     return "../../"+jsonfile.detaillink.ledgerdetails+"/"+id+"?date="+dateset;
        // }
        // else if(source === 'Invoice') {
        //     return "../../"+jsonfile.detaillink.invoice+"/"+id+"?date="+dateset;
        // }
        // else if(source === 'Credit Note') {
        //     return "../../"+jsonfile.detaillink.creditnote+"/"+id+"?date="+dateset;
        // }
        // else {
        //     return "../../"+jsonfile.detaillink.journal+"/"+id+"?date="+dateset;
        // }
        return "../../accounts/ledger?account_id="+id+"&date="+dateset;
    }

    const getFields = () => {
        const count = expand ? 10 : 6;
        const children = [];
        const inputs = jsonfile.input;

        inputs.map((list, index) => {
            if (list.isFilterable == 1) {
                children.push(
                    <Col lg={6} md={6} sm={12} xs={24} key={index} style={{display: index < count ? 'block' : 'none'}}>
                        <div className="gx-form-row0">
                            <Form.Item
                                name={`${list.name}`}
                                label={`${list.label}`}
                                rules={[
                                    {
                                        required: true,
                                        message: "",
                                    },
                                ]}
                            >
                                <Input placeholder={list.name}/>
                            </Form.Item>
                        </div>
                    </Col>,
                );
            }
        });
        return children;
    };

    const [expand, setExpand] = useState(false);
    const [form] = Form.useForm();

    const onFinish = values => {
        let wkd = "";
        let wk = "";
        let dt = [];
        console.log("Lookup Started");
        let reprotType = "periodical";
        // document.getElementById("loader").style.display = "block";
        const qs = Object.keys(values).map(key => {
                if (key === 'date') {
                    wk = formRef.current.getFieldValue('date');
                    const dtv = values[key] || moment().format("YYYY-01-01") + "," + moment().format("YYYY-12-31");
                    const dtvc = values[key] || "";
                    if (dtvc === "") {
                        dt.push(moment().format("YYYY-01-01"));
                        dt.push(moment().format("YYYY-12-31"));
                    } else {
                        dt = CisUI().ParseDateFormat(dtv);
                    }

                    setDate(dt);

                    //console.log("Dates : "+dt[1]);
                    return `${key}=${dt}`
                } else if (key === 'month') {
                    // wk = formRef.current.getFieldValue('month');
                    wk = form.getFieldValue("month");
                    // console.log("Selected Week : "+ wk);
                    wkd = CisUI().getMonthTitle(wk);
                    return `${key}=${wkd[1]}`;
                } else if (key === 'reporttype') {
                    if(values['reporttype'] === 'periodical') {
                        //setReportType("periodical");
                        reprotType = "periodical";
                    }
                    else {
                      // setReportType("comparative");
                       reprotType = "comparative";
                    }
                    return `${key}=${values[key]}`;
                } else {
                    return `${key}=${values[key]}`;
                }
            }
        ).join('&');

        console.log("Query String processed");

        let ReprotPeriod = "For the End of " + CisUI().getMonthTitle(dt[1]);
        let CurrentYear = "as of " + CisUI().getMonthTitle(dt[1]);
        let LastYear = "";

        if (values['reporttype'] === 'comparative') {
            const pv = CisUI().PeriodValue(values['period']);
            console.log(pv);
            // setPeriod("Comparative Report For the End of " + CisUI().getMonthTitle(dt[1]) + " and " + CisUI().getMonthTitle(moment(dt[1], "YYYY-MM-DD").subtract(pv[0], pv[1])));
            ReprotPeriod = ("Comparative Report For the End of " + CisUI().getMonthTitle(dt[1]) + " and " + CisUI().getMonthTitle(moment(dt[1], "YYYY-MM-DD").subtract(pv[0], pv[1])));
            CurrentYear = "as of " + CisUI().getMonthTitle(dt[1]);
            LastYear = "as of " + CisUI().getMonthTitle(moment(dt[1], "YYYY-MM-DD").subtract(pv[0], pv[1]));

            // setReportYear({
            //     currentYear: "as of " + CisUI().getMonthTitle(dt[1]),
            //     lastYear: "as of " + CisUI().getMonthTitle(moment(dt[1], "YYYY-MM-DD").subtract(pv[0], pv[1]))
            // });
            // values['date2'] = [dt[1], moment(dt[1], "YYYY-MM-DD").subtract(pv[0], pv[1])];
            values['date2'] = dt[1]+","+moment(dt[1], "YYYY-MM-DD").subtract(pv[0], pv[1]).format("YYYY-MM-DD");
        }
        else if (values['reporttype'] === 'comparative2') {
            const pv = CisUI().PeriodValue(values['period']);
            console.log(pv);
            const last = CisUI().getMonthTitle(moment(dt[1], "YYYY-MM-DD").subtract(1, "year"));
            // setPeriod("Comparative Report For the End of " + CisUI().getMonthTitle(dt[1]) + " and " + last);
            ReprotPeriod = ("Comparative Report For the End of " + CisUI().getMonthTitle(dt[1]) + " and " + last);
            CurrentYear = "as of " + CisUI().getMonthTitle(dt[1]);
            LastYear = "as of " + last;
            // setReportYear({
            //     currentYear: "as of " + CisUI().getMonthTitle(dt[1]),
            //     lastYear: "as of " + last
            // });
            values['date2'] = +moment(dt[0], "YYYY-MM-DD").subtract(1, "year").format("YYYY-MM-DD")+","+moment(dt[1], "YYYY-MM-DD").subtract(1, "year").format("YYYY-MM-DD");
        }
        else {
            values["date2"] = null;
        }

        console.log("Report Header processed");
        // const qsup = "";
        const qsup = qs.replaceAll("undefined", "");
        //reqURL = reqURL+"/?"+qsup;
       history.push("?" + qsup+"&date2="+values["date2"]);
        const newURL = Config.apiserver + jsonfile.urls.list + "?" + qsup+"&date2="+values["date2"];
        setState({
            reqURL: newURL,
            filtervalue: '',
            subtitle: '',
            period: ReprotPeriod,
            currentYear: CurrentYear,
            lastYear: LastYear,
            reporttype: reprotType
        });
        getLedgerData(newURL);
    };

    const handleOnFilter = ({target: {name, value}}) => {
        //filterValue = value;
        // console.log("filteringwith :"+ value);
        setState({filtervalue: "test"});
    }

    const OnPeriodChange = (e) => {
        CisUI().OnPeriodChange(e,form);
    }

    let searchView = "";
    if (jsonfile.has_search) {
        searchView = <Card className="advance-search-card no-print">
            <Collapse
                accordion
                expandIconPosition="right"
                defaultActiveKey={['1']}>
                <Panel header="Advance Search" key="1">
                    <Form
                        key={5}
                        form={form}
                        {...CisUI().formItemLayout}
                        ref={formRef}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                    >
                        {AdvancedSearch(jsonfile.search, "", 1,"",CisUI().PeriodFiled(form))}
                    </Form>
                </Panel>
            </Collapse>
        </Card>
    }

    const print = () => {
        window.open(Config.baseurl + "reports/stmntoffinpositionprint.html?url=" + window.btoa(state.reqURL) + "&filename=statement_of_financial_position&data=stmntoffinpositionData&subtitle=" + period + "&rptype=stmntoffinposition", "_blank");
    }
    
    const getExcelData = () => {
        // window.open(Config.baseurl + "data/getbalancesheetdata?")
        
        // console.log(urlParams(data))
    
        const urlParams = new URLSearchParams(window.location.search);
        // const apiurl = window.atob(urlParams.get('url'));
        console.log(reportyear)
        
        let reporttype = urlParams.get('reporttype');
        let period = urlParams.get('period');
        let date = urlParams.get('date');
    
        let data = {
            token: localStorage.getItem('token'),
            reporttype: reporttype,
            period: period,
            date: date,
            reportyear: reportyear
        }
        // console.log(data);
        
        // window.open(Config.apiserver + "data/getbalancesheetdata?data=" + window.btoa(localStorage.getItem('token')) + "&url=" + window.btoa(state.reqURL) , "_blank")
        window.open(Config.apiserver + "data/getbalancesheetdata?data=" + window.btoa(JSON.stringify(data)),"_blank")
        // axios.get(Config.apiserver + "data/getbalancesheetdata", data)
        //     .then(res => console.log("ok"))
        //     .catch(error => console.log(error))
    }

    const getAPIDataXLS = (APIUrl,qrystring) => {
        let URL  = APIUrl+"/xls?"+qrystring+"&token="+localStorage.getItem("token") || 0;
        if(APIUrl.includes("?")) {
            const sp = APIUrl.split("?");
            URL  = sp[0]+"/xls?"+sp[1]+"&token="+localStorage.getItem("token") || 0;
        }
        console.log("URL :"+URL);
        window.open(URL,"_blank");
    };

    const listAction = () =>
        (
            <div className="no-print">
                <a id="rploader" style={{width: '40px', height: '40px', display: 'none'}}>
                    <img src="/assets/images/loader.svg" style={{width: '40px', height: '40px'}} alt="loader"/> Please
                    wait ...
                </a>
                {/*<button className="btn btn-export-excel btn-circle-md" onClick={(e) => getAPIData()} title="Export to Excel"><i*/}
                {/*    className="fas fa-file-excel"/></button>*/}
                {/*<button className="btn btn-export-pdf btn-circle-md" onClick={exportToPDF} title="Export to PDF"><i*/}
                {/*    className="fas fa-file-pdf"/></button>*/}
                {/*<button className="btn btn-export-word btn-circle-md" onClick={exportToDocs} title="Export MS Word"><i*/}
                {/*    className="fas fa-file-word"/></button>*/}

                <button onClick={print} className="btn btn-export-print btn-circle-md" title="Print"><i
                    className="fas fa-print"/></button>

                <button className="btn btn-export-excel btn-circle-md" onClick={(e) => getAPIDataXLS(state.reqURL,"")} title="Export to Excel"><i
                    className="fas fa-file-excel"/></button>

            </div>
        );

    const getExtra = (
        <>
            {/*{CisUI().listActionReportXLS("","",state.reqURL,"data","income_statement",jsonfile,"Income Statement")}*/}

            {listAction()}
        </>
    );


    const setCollapse = (id) => {
        console.log("Slcct: ", id);
        if (hide.indexOf(id) > -1) {
            var index = hide.indexOf(id); // Let's say it's Bob.
            hide.splice(index, 1);
            document.getElementById("icon_" + id).setAttribute("class", "fas fa-chevron-right")
            var row = document.getElementsByClassName("disp_" + id);
            var thisYear = document.getElementsByClassName("this_" + id);
            var lastYear = document.getElementsByClassName("lasty_" + id);

            var i;
            for (i = 0; i < row.length; i++) {
                //row[i].style.display = 'inherit';
                //row[i].removeAttribute('style');
                row[i].style.display = 'none';
            }

            for (i = 0; i < thisYear.length; i++) {
                thisYear[i].removeAttribute('style');
                if(reporttype === 'comparative') {
                    lastYear[i].removeAttribute('style');
                }
            }
        } else {
            const hd = hide;
            hd.push(id);
            setHide(hd);
            document.getElementById("icon_" + id).setAttribute("class", "fas fa-chevron-down");
            var row = document.getElementsByClassName("disp_" + id);
            var thisYear = document.getElementsByClassName("this_" + id);
            var lastYear = document.getElementsByClassName("lasty_" + id);
            var i;
            for (i = 0; i < row.length; i++) {
                //row[i].style.display = 'none';
                row[i].removeAttribute('style');
            }

            for (i = 0; i < thisYear.length; i++) {
                //row[i].style.display = 'none';
                thisYear[i].style.display = "none";
                if(reporttype === 'comparative') {
                    lastYear[i].style.display = "none";
                }
            }
        }
        console.log("hides : ", hide);
    }

    let totalDebit = 0;
    let totalCredit = 0;

    return (
        <>
            {searchView}
            <Card extra={getExtra}>
                {CisUI().showLoading}
                {resp.status === 1 ?
                    <div>
                        <div className="table-responsive">
                            <div style={{textAlign: 'center'}}>
                                <h2>{header}</h2>
                                <h4>Balance Sheet</h4>
                                <h4>{state.period}</h4>
                            </div>

                            <table className="statement table mx-auto w-auto">
                                <thead>
                                <tr>
                                    <th style={{width: '400px'}}>Particulars</th>
                                    <th style={{textAlign: 'right', width: '130px'}}>{state.currentYear}</th>
                                    {state.reporttype === 'comparative' ?
                                        <th style={{textAlign: 'right', width: '130px'}}>{state.lastYear}</th>
                                        : ""}
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td colSpan={4} style={{fontWeight: 'bold'}}>ASSETS</td>
                                </tr>
                                <tr>
                                    <td colSpan={3} style={{fontWeight: 'bold'}}>
                                        <div className="subItemText">Current Asset</div>
                                    </td>
                                </tr>
                                {
                                    resp.data[0]["assets"]["currentAsset"].map((itmes, index) => {
                                        var row = [];
                                        row.push(<tr>
                                            <td style={{fontWeight: 'normal'}}>
                                                <div className="subItemText2">
                                                    {itmes["childTree"].length > 0 ?
                                                        <span style={{marginLeft: '-10px'}}><i id={"icon_" + itmes.id}
                                                                                               onClick={() => setCollapse(itmes.id)}
                                                                                               className="fas fa-chevron-right"/> </span>
                                                        : <></>}
                                                    {itmes.name}
                                                </div>
                                            </td>
                                            <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"this_" + itmes.id} ><Link to={getDetailsLink("Ledger",itmes.id)}>{CisUI().getCurrencyFormated1(itmes.thisYear)}</Link></span></td>
                                            {state.reporttype === 'comparative' ?
                                                <td style={{
                                                    textAlign: 'right',
                                                    fontWeight: 'normal'
                                                }}><span className={"lasty_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.lastYear)}</span></td>
                                                : ""}
                                        </tr>)
                                        itmes["childTree"].map((itm, indx) => {
                                            if(itm.row === 'total')
                                            {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemTextTotal">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                            else {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemText3">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                        })
                                        return row;
                                    })
                                }
                                <tr className="showTotalBorder">
                                    <td style={{fontWeight: 'bold'}}>
                                        <div className="subItemText3">Total Current Assets</div>
                                    </td>
                                    <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["assets"]["totalCurAssetY1"])}</td>
                                    {state.reporttype === 'comparative' ? <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["assets"]["totalCurAssetY2"])}</td> : ""}
                                </tr>
                                <tr>
                                    <td colSpan={3} style={{fontWeight: 'bold'}}>
                                        <div className="subItemText">Non-Current Asset</div>
                                    </td>
                                </tr>
                                {
                                    resp.data[0]["assets"]["othersAsset"].map((itmes, index) => {
                                        var row = [];
                                        row.push(<tr>
                                            <td style={{fontWeight: 'normal'}}>
                                                <div className="subItemText2">
                                                    {itmes["childTree"].length > 0 ?
                                                        <span style={{marginLeft: '-10px'}}><i id={"icon_" + itmes.id}
                                                                                               onClick={() => setCollapse(itmes.id)}
                                                                                               className="fas fa-chevron-right"/> </span>
                                                        : <></>}
                                                    {itmes.name}
                                                </div>
                                            </td>
                                            <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"this_" + itmes.id} ><Link to={getDetailsLink("Ledger",itmes.id)}>{CisUI().getCurrencyFormated1(itmes.thisYear)}</Link></span></td>
                                            {state.reporttype === 'comparative' ? <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"lasty_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.lastYear)}</span></td> : ""}
                                        </tr>)
                                        itmes["childTree"].map((itm, indx) => {
                                            if(itm.row === 'total')
                                            {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemTextTotal">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                            else {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemText3">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                        })
                                        return row;
                                    })
                                }
                                <tr className="showTotalBorder">
                                    <td style={{fontWeight: 'bold'}}>
                                        <div className="subItemText3">Total Non-Current Assets</div>
                                    </td>
                                    <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["assets"]["totalOtrAssetY1"])}</td>
                                    {state.reporttype === 'comparative' ? <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["assets"]["totalOtrAssetY2"])}</td> : ""}
                                </tr>

                                <tr>
                                    <td colSpan={3} style={{fontWeight: 'bold'}}>
                                        <div className="subItemText">Fixed Assets</div>
                                    </td>
                                </tr>
                                {
                                    resp.data[0]["assets"]["fixedAssets"].map((itmes, index) => {
                                        var row = [];
                                        row.push(<tr>
                                            <td style={{fontWeight: 'normal'}}>
                                                <div className="subItemText2">
                                                    {itmes["childTree"].length > 0 ?
                                                        <span style={{marginLeft: '-10px'}}><i id={"icon_" + itmes.id}
                                                                                               onClick={() => setCollapse(itmes.id)}
                                                                                               className="fas fa-chevron-right"/> </span>
                                                        : <></>}
                                                    {itmes.name}
                                                </div>
                                            </td>
                                            <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"this_" + itmes.id} ><Link to={getDetailsLink("Ledger",itmes.id)}>{CisUI().getCurrencyFormated1(itmes.thisYear)}</Link></span></td>
                                            {state.reporttype === 'comparative' ? <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"lasty_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.lastYear)}</span></td> : ""}
                                        </tr>)
                                        itmes["childTree"].map((itm, indx) => {
                                            if(itm.row === 'total')
                                            {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemTextTotal">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                            else {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemText3">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                        })
                                        return row;
                                    })
                                }

                                <tr className="showTotalBorder">
                                    <td style={{fontWeight: 'bold'}}>
                                        <div className="subItemText3">Total Fixed Assets</div>
                                    </td>
                                    <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["assets"]["totalFixAssetY1"])}</td>
                                    {state.reporttype === 'comparative' ? <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["assets"]["totalFixAssetY2"])}</td> : ""}
                                </tr>

                                <tr>
                                    <td colSpan={3} style={{fontWeight: 'bold'}}>
                                        <div className="subItemText">Long Term Assets</div>
                                    </td>
                                </tr>
                                {
                                    resp.data[0]["assets"]["longAssets"].map((itmes, index) => {
                                        var row = [];
                                        row.push(<tr>
                                            <td style={{fontWeight: 'normal'}}>
                                                <div className="subItemText2">
                                                    {itmes["childTree"].length > 0 ?
                                                        <span style={{marginLeft: '-10px'}}><i id={"icon_" + itmes.id}
                                                                                               onClick={() => setCollapse(itmes.id)}
                                                                                               className="fas fa-chevron-right"/> </span>
                                                        : <></>}
                                                    {itmes.name}
                                                </div>
                                            </td>
                                            <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"this_" + itmes.id} ><Link to={getDetailsLink("Ledger",itmes.id)}>{CisUI().getCurrencyFormated1(itmes.thisYear)}</Link></span></td>
                                            {state.reporttype === 'comparative' ? <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"lasty_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.lastYear)}</span></td> : ""}
                                        </tr>)
                                        itmes["childTree"].map((itm, indx) => {
                                            if(itm.row === 'total')
                                            {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemTextTotal">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                            else {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemText3">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                        })
                                        return row;
                                    })
                                }

                                <tr className="showTotalBorder">
                                    <td style={{fontWeight: 'bold'}}>
                                        <div className="subItemText3">Total Long Term Assets</div>
                                    </td>
                                    <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["assets"]["totalLongAssetY1"])}</td>
                                    {state.reporttype === 'comparative' ? <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["assets"]["totalLongAssetY2"])}</td> : ""}
                                </tr>

                                <tr className="showTotalBorderDouble">
                                    <td className="clmintent" style={{fontWeight: 'bold'}}>Total ASSETS</td>
                                    <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["assets"]["totalAssetY1"])}</td>
                                    {state.reporttype === 'comparative' ? <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["assets"]["totalAssetY2"])}</td> : ""}
                                </tr>

                                <tr>
                                    <td colSpan={3} style={{fontWeight: 'bold'}}></td>
                                </tr>

                                <tr>
                                    <td colSpan={3} style={{fontWeight: 'bold'}}>
                                        <div style={{paddingTop: '20px'}}>LIABILITIES AND NET ASSETS</div>
                                    </td>
                                </tr>

                                <tr>
                                    <td colSpan={3} style={{fontWeight: 'bold'}}>
                                        <div className="subItemText">Current Liabilities</div>
                                    </td>
                                </tr>
                                {
                                    resp.data[0]["liability"]["currentLiability"].map((itmes, index) => {
                                        var row = [];
                                        row.push(<tr>
                                            <td style={{fontWeight: 'normal'}}>
                                                <div className="subItemText2">
                                                    {itmes["childTree"].length > 0 ?
                                                        <span style={{marginLeft: '-10px'}}><i id={"icon_" + itmes.id}
                                                                                               onClick={() => setCollapse(itmes.id)}
                                                                                               className="fas fa-chevron-right"/> </span>
                                                        : <></>}
                                                    {itmes.name}
                                                </div>
                                            </td>
                                            <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"this_" + itmes.id} ><Link to={getDetailsLink("Ledger",itmes.id)}>{CisUI().getCurrencyFormated1(itmes.thisYear)}</Link></span></td>
                                            {state.reporttype === 'comparative' ? <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"lasty_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.lastYear)}</span></td> : ""}
                                        </tr>)
                                        itmes["childTree"].map((itm, indx) => {
                                            if(itm.row === 'total')
                                            {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemTextTotal">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                            else {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemText3">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                        })
                                        return row;
                                    })
                                }
                                <tr className="showTotalBorder">
                                    <td style={{fontWeight: 'bold'}}>
                                        <div className="subItemText3">Total Current Liabilities</div>
                                    </td>
                                    <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["liability"]["totalCurLiabilityY1"])}</td>
                                    {state.reporttype === 'comparative' ? <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["liability"]["totalCurLiabilityY2"])}</td> : ""}
                                </tr>

                                <tr>
                                    <td colSpan={3} style={{fontWeight: 'bold'}}>
                                        <div className="subItemText">Non-Current Liabilities</div>
                                    </td>
                                </tr>
                                {
                                    resp.data[0]["liability"]["othersLiablity"].map((itmes, index) => {
                                        var row = [];
                                        row.push(<tr>
                                            <td style={{fontWeight: 'normal'}}>
                                                <div className="subItemText2">
                                                    {itmes["childTree"].length > 0 ?
                                                        <span style={{marginLeft: '-10px'}}><i id={"icon_" + itmes.id}
                                                                                               onClick={() => setCollapse(itmes.id)}
                                                                                               className="fas fa-chevron-right"/> </span>
                                                        : <></>}
                                                    {itmes.name}
                                                </div>
                                            </td>
                                            <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"this_" + itmes.id} ><Link to={getDetailsLink("Ledger",itmes.id)}>{CisUI().getCurrencyFormated1(itmes.thisYear)}</Link></span></td>
                                            {state.reporttype === 'comparative' ? <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"lasty_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.lastYear)}</span></td> : ""}
                                        </tr>)
                                        itmes["childTree"].map((itm, indx) => {
                                            if(itm.row === 'total')
                                            {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemTextTotal">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                            else {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemText3">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                        })
                                        return row;
                                    })
                                }
                                <tr className="showTotalBorder">
                                    <td style={{fontWeight: 'bold'}}>
                                        <div className="subItemText3">Total Non-Current Liabilities</div>
                                    </td>
                                    <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["liability"]["totalOtrLiabilityY1"])}</td>
                                    {state.reporttype === 'comparative' ? <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["liability"]["totalOtrLiabilityY2"])}</td> : ""}
                                </tr>
                                <tr className="showTotalBorder">
                                    <td className="clmintent" style={{fontWeight: 'bold'}}>Total LIABILITIES</td>
                                    <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["liability"]["totalLiabilityY1"])}</td>
                                    {state.reporttype === 'comparative' ? <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["liability"]["totalLiabilityY2"])}</td> : ""}
                                </tr>
                                <tr>
                                    <td colSpan={3} style={{fontWeight: 'bold'}}>
                                        <div className="subItemText">Net Assets/Net Income</div>
                                    </td>
                                </tr>
                                {
                                    resp.data[0]["liability"]["netIncome"].map((itmes, index) => {
                                        var row = [];
                                        row.push(<tr>
                                            <td style={{fontWeight: 'normal'}}>
                                                <div className="subItemText2">
                                                    {itmes["childTree"].length > 0 ?
                                                        <span style={{marginLeft: '-10px'}}><i id={"icon_" + itmes.id}
                                                                                               onClick={() => setCollapse(itmes.id)}
                                                                                               className="fas fa-chevron-right"/> </span>
                                                        : <></>}
                                                    {itmes.name}
                                                </div>
                                            </td>
                                            <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"this_" + itmes.id} ><Link to={getDetailsLink("Ledger",itmes.id)}>{CisUI().getCurrencyFormated1(itmes.thisYear)}</Link></span></td>
                                            {state.reporttype === 'comparative' ? <td style={{
                                                textAlign: 'right',
                                                fontWeight: 'normal'
                                            }}><span className={"lasty_" + itmes.id} >{CisUI().getCurrencyFormated1(itmes.lastYear)}</span></td> : ""}
                                        </tr>)
                                        itmes["childTree"].map((itm, indx) => {
                                            if(itm.row === 'total')
                                            {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemTextTotal">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'bold'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                            else {
                                                row.push(<tr className={"disp_" + itmes.id} style={{display: "none"}}>
                                                    <td style={{fontWeight: 'normal'}}>
                                                        <div className="subItemText3">{itm.name}</div>
                                                    </td>
                                                    <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}><Link to={getDetailsLink("Ledger",itm.id)}>{CisUI().getCurrencyFormated1(itm.thisYear)}</Link></td>
                                                    {state.reporttype === 'comparative' ? <td style={{
                                                        textAlign: 'right',
                                                        fontWeight: 'normal'
                                                    }}>{CisUI().getCurrencyFormated1(itm.lastYear)}</td> : ""}
                                                </tr>)
                                            }
                                        })
                                        return row;
                                    })
                                }
                                <tr className="showTotalBorder">
                                    <td style={{fontWeight: 'bold'}}>
                                        <div className="subItemText3">Total Net Assets/Net Income</div>
                                    </td>
                                    <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["liability"]["totalIncomeY1"])}</td>
                                    {state.reporttype === 'comparative' ? <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["liability"]["totalIncomeY2"])}</td> : ""}
                                </tr>
                                <tr className="showTotalBorderDouble">
                                    <td className="clmintent" style={{fontWeight: 'bold'}}>Total Liabilities and Net
                                        Assets
                                    </td>
                                    <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["liability"]["totalLiabilityEndY1"])}</td>
                                    {state.reporttype === 'comparative' ? <td style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold'
                                    }}>{CisUI().getCurrencyFormated1(resp.data[0]["liability"]["totalLiabilityEndY2"])}</td> : ""}
                                </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                    : <></>}

            </Card>
        </>
    );
};

export default BalanceSheet;